/**
 * Drawer Component Script
 *
 * This script enables a sliding drawer component that appears when a trigger button is clicked.
 * The drawer can be closed by clicking on the close button or the overlay.
 *
 * The simpliest structure to start with:
 * 
<button class="js-drawer-cta" for="drawer-{{ block.id }}">
    open drawer
</button>
<div class="drawer-simple js-drawer" role="dialog" id="drawer-{{ block.id }}">
    <div class="drawer-overlay js-drawer-close"></div>    
    <div class="drawer-inner relative">
        <div class="drawer-header">
          Title
          <span role="button" class="drawer-close-btn js-drawer-close">
            {% render 'icon', icon: 'close' %}
          </span>
        </div>
        <div class="drawer-content">
            
        </div>
    </div>
</div>
 *
 */
(function () {
  let isInitialized = false;
  let openDrawerCta, closeCta;

  function initializeDrawer() {
    if (isInitialized) return;
    isInitialized = true;
    openDrawerCta = document.querySelectorAll('.js-drawer-cta');
    closeCta = document.querySelectorAll('.js-drawer-close');

    let ctaIndex = 0;
    const chunkSize = 3;

    function processDrawerCtas() {
      const endIndex = Math.min(ctaIndex + chunkSize, openDrawerCta.length);

      for (let i = ctaIndex; i < endIndex; i++) {
        const cta = openDrawerCta[i];
        const drawer = document.getElementById(cta.getAttribute('for'));
        if (drawer) {
          cta.addEventListener('click', openDrawer, { passive: true });
          document.body.append(drawer);
          drawer.classList.add('inited');
        }
      }

      ctaIndex = endIndex;

      if (ctaIndex < openDrawerCta.length) {
        requestAnimationFrame(() => {
          setTimeout(processDrawerCtas, 16);
        });
      }
    }

    closeCta.forEach((cta) => {
      cta.addEventListener('click', closeDrawer, { passive: true });
    });

    if (openDrawerCta.length > 0) {
      setTimeout(processDrawerCtas, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDrawer);
  } else {
    setTimeout(initializeDrawer, 0);
  }

  function openDrawer(e) {
    const drawerId = e.currentTarget.getAttribute('for');
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;

    requestAnimationFrame(() => {
      drawer.classList.add('opened');
      document.body.classList.add('no-scroll');
    });
  }

  function closeDrawer(e) {
    const drawer = e.currentTarget.closest('.js-drawer');
    if (!drawer) return;

    requestAnimationFrame(() => {
      drawer.classList.remove('opened');
      document.body.classList.remove('no-scroll');
    });
  }
})();
